/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type missionControlHeader_viewer$ref = any;
export type NPS_TYPE = "MY_TASKS" | "MY_WORK" | "NPS" | "NPS_EMOJI" | "NPS_NEW" | "OVERVIEW" | "TIME" | "TIMESHEETS" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type npsResults_viewer$ref: FragmentReference;
declare export opaque type npsResults_viewer$fragmentType: npsResults_viewer$ref;
export type npsResults_viewer = {|
  +id: string,
  +missionControlData: ?{|
    +id: string,
    +npsResults: ?$ReadOnlyArray<?{|
      +id: string,
      +date: ?string,
      +type: ?NPS_TYPE,
      +score: ?number,
      +comment: ?string,
      +companyName: ?string,
      +personName: ?string,
      +personRole: ?string,
      +personEmail: ?string,
      +personType: ?string,
      +personErrors: ?number,
    |}>,
  |},
  +$fragmentRefs: missionControlHeader_viewer$ref,
  +$refType: npsResults_viewer$ref,
|};
export type npsResults_viewer$data = npsResults_viewer;
export type npsResults_viewer$key = {
  +$data?: npsResults_viewer$data,
  +$fragmentRefs: npsResults_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "npsResults_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlDataType",
      "kind": "LinkedField",
      "name": "missionControlData",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlNpsResultsType",
          "kind": "LinkedField",
          "name": "npsResults",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "score",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "comment",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "personName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "personRole",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "personEmail",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "personType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "personErrors",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "missionControlHeader_viewer"
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = '0ed8ae1368e770772ff85e9b564a73cf';

module.exports = node;
